import { Navigate, useLocation } from 'react-router-dom';
import { useFloorManager } from '../context/FloorManagerContext';

const ProtectedFloorManagerRoute = ({ children }) => {
  const { user, initialized } = useFloorManager();
  const location = useLocation();

  if (!initialized) {
    return null;
  }

  if (!user) {
    return (
      <Navigate
        to="/lkart/supervisor-login"
        state={{ redirectUrl: location.pathname + location.search }}
        replace
      />
    );
  }

  return children;
};

export default ProtectedFloorManagerRoute;